import {
	CurrencyType,
	DiscountTargetType,
	DiscountTermType,
	DiscountType,
	SaleTypeForPlan,
	SaleTypeForTerm,
} from "@/lib/gql/__generated__/graphql";

import type * as DiscountItemOrdinaryShared from "../../../../../_shared";
import type * as QueryRepository from "../../../repository/query";

type InputModel = DiscountItemOrdinaryShared.Model.ModelType.DiscountOrdinaryFormModel["InputModel"];

export const serverModelToInputModelConverter = (
	hotelID: string,
	serverModel: QueryRepository.DiscountOrdinaryForOrdinaryServerModel,
): InputModel => {
	if (!serverModel.discountOrdinary) {
		return {
			hotelID,
			discountID: "",
			// 基本設定
			// 公開・非公開
			inSale: false,
			// ディスカウントの名前
			name: "",
			// ディスカウントの説明
			description: "",
			// ディスカウントのコード
			discountCode: "",
			// ディスカウント金額
			discountType: DiscountType.Ratio,
			ratio: 10,
			// ディスカウント対象
			staticTargetType: DiscountTargetType.PerGroup,
			// ディスカウント対象
			staticTermType: DiscountTermType.PerReservation,
			// 最低提供価格
			resourceLowestPrice: {
				amount: 1000,
				currencyType: CurrencyType.Jpy,
			},

			// 追加設定
			// キャンセル不可にするか
			isUncancelable: false,
			// 販売タイプ
			saleTypeForPlan: SaleTypeForPlan.Limited,
			// 利用可能期間
			saleTypeForTerm: SaleTypeForTerm.Always,
		} as InputModel;
	}

	const { discountOrdinary } = serverModel;
	return {
		...discountOrdinary,
		ratio: discountOrdinary.discountType === DiscountType.Ratio ? (discountOrdinary.ratio ?? 10) : undefined,
		static:
			discountOrdinary.discountType === DiscountType.Static
				? (discountOrdinary.static ?? {
						amount: 1000,
						currencyType: CurrencyType.Jpy,
					})
				: undefined,
		isPlanDiscountEligible: discountOrdinary.isPlanDiscountEligible ?? true,
		isRoomDiscountEligible: discountOrdinary.isRoomDiscountEligible ?? true,
		isOptionDiscountEligible: discountOrdinary.isOptionDiscountEligible ?? true,
		isAdditionalFeeDiscountEligible: discountOrdinary.isAdditionalFeeDiscountEligible ?? true,
	} as InputModel;
};
